'use client';

import { Breakpoint, useIsBreakpoint } from '@/hooks/useIsBreakpoint';
import { trackCtaClick } from '@/utils/tracking';
import { LinkButton } from '../LinkButton/LinkButton';

interface ContactCTAProps {
  title: string;
  subtitle?: string;
  buttonText: string;
  buttonUrl: string;
  image?: string;
}

export const ContactCTA: React.FC<ContactCTAProps> = ({ title, subtitle, buttonText, buttonUrl, image }) => {
  const isMobile = useIsBreakpoint(Breakpoint.LG);

  return (
    <div
      className="flex min-h-40 flex-col bg-none md:flex-row"
      style={
        !isMobile
          ? {
              backgroundImage: image ? `url(${image})` : undefined,
              backgroundPosition: 'right bottom',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'auto 90%',
            }
          : {}
      }
    >
      <div className="w-full py-12 lg:w-1/2">
        {subtitle && <div className="tc-heading-xs mt-0">{subtitle}</div>}
        <h2 className="tc-heading-2xl mt-0 mb-6 md:mb-8">{title}</h2>
        <LinkButton
          link={buttonUrl}
          label={buttonText}
          size="medium"
          variant="primary"
          onClick={() => trackCtaClick(buttonText, 'contact_cta')}
        />
      </div>
    </div>
  );
};
